module.exports = __webpack_public_path__ + "static/media/police.1bb98f64.jpg";